import Scene = Phaser.Scene;
import Container = Phaser.GameObjects.Container;
import Image = Phaser.GameObjects.Image;
import {Keys} from "@/constants/key";
import {BasePanel} from "@/scenes.ui/base-panel";
import {SquareButton} from "@/scenes.ui/square-button";
import SpriteUtils from "@/utils/sprite-utils";
import PlayerStore from "@/store/player";
import {Lang} from "@/store/player/types";
import { Tr } from "@/i18n/i18n";

export class RabbitScroll extends BasePanel {

    protected okButton!: SquareButton;
    protected window!: Image;
    protected onCloseCallback!: () => void;

    constructor(scene: Scene, canvas: HTMLCanvasElement) {
        super(scene, canvas, canvas.width / 2, canvas.height / 2 - 30, undefined);
        this.setDepth(3001);
        this.preInit();

        const self = this;

        let background = SpriteUtils.addSprite(this.scene, 0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setInteractive();
        SpriteUtils.setDispSize(background, canvas!.width * 2, canvas!.height * 2);
        this.add(background);

        let background2 = SpriteUtils.addSprite(this.scene, 0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setInteractive();
        SpriteUtils.setDispSize(background2, canvas!.width * 2, canvas!.height * 2);
        this.add(background2);

        let key = PlayerStore.getPlayer().lang === Lang.RU ? Keys.RAB_RU : Keys.RAB_EN;
        this.window = SpriteUtils.addImage(this.scene, 0, -80, key,
            self.getWindowScaleX(), self.getWindowScaleY()).setOrigin(0.5, 0.5);
        this.add(this.window);

        this.addCustomButton(scene, 0, 240, Tr('more'), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {
            self.close();
        });
    }

    public openAnimated(): void {
        this.doOpenAnimated(0, 1000);
    }

    protected preInit(): void {
        // do nothing
    }

    protected preClose(): void {
        // do nothing
    }

    protected addCustomButton(scene: Scene, x: number, y: number, text: string, buttonBackground: string,
                              buttonAtlas: string | undefined, buttonIcon: string | undefined,
                              callback?: () => unknown, disableAutoClose?: boolean): Container {
        let okButton = new SquareButton(this.scene, x, y, 0, buttonBackground,
            buttonAtlas, buttonIcon, text.toLocaleUpperCase(), false);

        okButton.setCallback(() => {
            if (this.isOnTop()) {
                if (callback != null) {
                    callback();
                }
                if (!disableAutoClose) {
                    this.closeWithCallback();
                }
            }
        });

        this.okButton = okButton;

        this.add(okButton);

        okButton.setAlpha(0);

        scene.tweens.add({
            targets: okButton,
            alpha: 1,
            delay: 1000,
            duration: 1000,

            onComplete: function () {
                okButton.setCallback(() => {
                    if (callback != null) {
                        callback();
                    }
                });
            },
        });

        return okButton;
    }

    public close(): void {
        this.preClose();
        BasePanel.stack = BasePanel.stack.filter(p => p != this);
        if (this.closeListener != null) {
            this.closeListener();
        }
        let self = this;
        if (this.scene && this.scene.scene.isActive()) {
            this.scene!.tweens.add({
                targets: this,
                alpha: 0,
                delay: 0,
                duration: 300,

                onComplete() {
                    self.setVisible(false);
                    self.destroy();
                }
            });
        } else {
            self.setVisible(false);
            self.destroy();
        }
    }

    public closeWithoutAnimation(): void {
        this.preClose();
        BasePanel.stack = BasePanel.stack.filter(p => p != this);
        if (this.closeListener != null) {
            this.closeListener();
        }
        let self = this;
        self.setVisible(false);
        self.destroy();
    }

    protected isClosable(): boolean {
        return true;
    }

    protected onClose(): void {
        if (this.onCloseCallback) {
            this.onCloseCallback();
        }
    }

    protected closeWithCallback() {
        this.onClose();
        this.close();
    }

    protected setOnCLoseCallback(callback: () => void) {
        this.onCloseCallback = callback;
    }

    protected getXButtonY(): number {
        return -286;
    }

    protected getXButtonX(): number {
        return 216;
    }

    protected getTitleY(): number {
        return -262;
    }

    protected getCloseButtonX(): number {
        return 0;
    }

    protected getCloseButtonY(): number {
        return 135;
    }

    protected getWindowScaleX(): number {
        return 1.0;
    };

    protected getWindowScaleY(): number {
        return 1.0;
    };

    protected getWindow(){
        return this.window;
    }
}
